import { APIS_BASE_URL } from '../constants/env';

export const getShipmentLabelsDownloadUrl = (shipmentId, labelType) =>
  `${APIS_BASE_URL}/shipments/${shipmentId}/${labelType}`;
